export { default } from './useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/useMediaQuery/index.js
// module id = 570
// module chunks = 2